import { Box, Menu } from '@gympass/yoga';
import MoreInformationIcon from 'icons/more-information.svg';
import { FormattedMessage } from 'react-intl';

import { useModals } from 'context';

import { DeliverContentModalComponentProps } from 'modals/index';

import { TCDashboardTableActionsProps } from './types';

import * as S from './styles';

const TCDashboardTableActions: React.FC<TCDashboardTableActionsProps> = ({
  patient,
}) => {
  const { openModal } = useModals();

  const sendContent = (isEnrollment: boolean) => () => {
    openModal<DeliverContentModalComponentProps>('deliverContent', {
      props: {
        endUserId: patient.cognitoId,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onAfterSubmit: () => {},
        isEnrollment,
      },
    });
  };

  const openChatOnNewWindow = () => {
    window.open(
      `/new-provider/care-provider/chat?cognito_id=${patient.cognitoId}`,
    );
  };

  return (
    <Box
      data-testid="tcDashboardTableActions"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Menu onMouseHover={false}>
        <Menu.Action>
          <S.IconButton
            data-testid="btnTCTableActions"
            icon={() => <MoreInformationIcon />}
            small
          />
        </Menu.Action>
        <Menu.List side="bottom">
          <S.MenuItem data-testid="btnSendProgram" onClick={sendContent(true)}>
            <FormattedMessage id="DASHBOARD.TC.MENUBUTTON.SENDCONTENT" />
          </S.MenuItem>
          <S.MenuItem data-testid="btnSendModule" onClick={sendContent(false)}>
            <FormattedMessage id="DASHBOARD.TC.BUTTON.SENDMODULE" />
          </S.MenuItem>
          <S.MenuItem data-testid="btnSendMsg" onClick={openChatOnNewWindow}>
            <FormattedMessage id="DASHBOARD.TC.BUTTON.SENDMESSAGE" />
          </S.MenuItem>
        </Menu.List>
      </Menu>
    </Box>
  );
};

export default TCDashboardTableActions;
